<script lang="ts">
  import SectionVirementReceivedList from '@/generated/sections/SectionVirementReceivedList.vue';
  import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { defineComponent } from "vue";

  export default defineComponent({
    components: {},
    extends: SectionVirementReceivedList,
    computed: {
      headers() {
        return [
          { text: "Date d'encaissement", value: 'datePayed', cellClass: '', sortable: true },
          { text: "Emetteur", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Référence", value: 'reference', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },
      pageLimit(): number {
        return 10;
      }
    },
    methods: {
      defaultFilter(): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.VIREMENT_RECU;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "statut";
          columnFilter.staticFilter = true;
          const payed = new ListChoix();
          payed.value = TransactionStatuts.PAYED;
          columnFilter.filters.push(payed);
          const billed = new ListChoix();
          billed.value = TransactionStatuts.BILLED;
          columnFilter.filters.push(billed);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "datePayed";
          columnFilter.sortDescending = true;
          this.activeFilters.push(columnFilter);
        }
      }
    }
  })

</script>
